import React, { useMemo } from 'react';
import type { TimeZone } from '@axiom/validation';
import { NO_TIMEZONE } from '@axiom/const';

import { CalendarTimeZoneUtil } from '../../../utils/calendar-time-zone-util';
import type {
  RawDropdownDirectionType,
  RawDropdownValueType,
} from '../Dropdown/RawDropdown';
import { RawDropdown } from '../Dropdown/RawDropdown';

export type RawTimezoneDropdownProps = {
  disabled?: boolean;
  direction?: RawDropdownDirectionType;
  id?: string;
  invalid?: boolean;
  name: string;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  onChange: (
    value: TimeZone['id'] | null,
    e?: React.SyntheticEvent<HTMLElement>,
    timezone?: TimeZone
  ) => void;
  onFocus: (e: React.FocusEvent<HTMLInputElement>) => void;
  placeholder?: string | null;
  value?: TimeZone['id'] | null;
};

export const RawTimezoneDropdown = ({
  disabled = false,
  direction,
  id,
  invalid = false,
  name,
  onBlur,
  onChange,
  onFocus,
  placeholder,
  value,
}: RawTimezoneDropdownProps) => {
  const timezoneOptions = useMemo(
    () => CalendarTimeZoneUtil.getDropDownOptions(),
    []
  );

  const handleChange = (
    selectedValue: RawDropdownValueType,
    e?: React.SyntheticEvent<HTMLElement>,
    _valueOption?: Record<string, unknown> | Array<Record<string, unknown>>
  ) => {
    const timezoneId = (selectedValue as TimeZone['id']) || null;
    const timezone = timezoneId
      ? CalendarTimeZoneUtil.getZoneFromId(timezoneId)
      : undefined;

    onChange(
      timezoneId,
      e,
      timezone && timezone !== NO_TIMEZONE ? timezone : undefined
    );
  };

  return (
    <RawDropdown
      direction={direction}
      displayKey="label"
      disabled={disabled}
      id={id}
      invalid={invalid}
      name={name}
      onBlur={onBlur}
      onChange={handleChange}
      onFocus={onFocus}
      options={timezoneOptions}
      placeholder={placeholder}
      value={value}
      valueKey="value"
    />
  );
};
